import { z } from "zod";
export const VerifyTwoFactor = z.object({
    code: z.string().length(6),
    publicId: z.string(),
});
//# sourceMappingURL=2fa-verify.js.map